<template>
  <div class="row p-3">
    <b-col cols="12">
      <b-card>
        <div slot="header">
          <div class="float-left">{{ $lang.searchRole }}</div>
          <div class="float-right">
            <router-link
              v-b-tooltip.hover
              :title="$lang.One_source_access_for_all_roles"
              class="btn btn-link btn-lightgray"
              to="accessForAllRoles"
            >
              <i class="fas fa-user-tag"></i>
            </router-link>
          </div>
        </div>
        <div class="card-body p-0">
          <TreePage
            :showAlert="false"
            :showRoleSelected="false"
            :dynamicButton="buttonRole"
            :refreshRole="refreshRole"
            :parentLoading="isLoading"
            @methodOnClick="methodOnClick"
            @updateRefreshRole="updateRefreshRole"
          />
        </div>
      </b-card>
    </b-col>
    <b-modal
      content-class="border-primary"
      header-bg-variant="primary"
      no-close-on-backdrop
      size="xl"
      v-model="view_modal_role"
      variant="primary"
      hide-header
      hide-footer
    >
      <AddRole
        v-if="mode === 'add'"
        :loading="isLoading"
        :parent_role_name="parent_role_name"
        @submit="addRole"
        @close="closeModal"
      />
      <EditRole
        v-if="mode === 'edit' && allowEdit"
        :loading="isLoading"
        :code="code"
        @submit="editRole"
        @close="closeModal"
      />
      <SyncRole
        v-if="mode === 'sync'"
        :loading="isLoading"
        :item="synchronizeItem"
        @submit="syncRole"
        @close="closeModal"
      />
    </b-modal>
    <Confirm
      :title="$lang.search.delete_modal_title"
      :description="messageConfirm"
      :loading="isLoading"
      v-model="changeModal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="remove_item"
      @cancel="cancel"
    />
  </div>
</template>

<script>
import TreePage from "@/components/tree/treePage";
import AddRole from "../role/addRole";
import EditRole from "../role/editRole";
import SyncRole from "../role/syncRole";
import Confirm from "@/components/base/confirm";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "role-tree",
  components: {
    TreePage,
    AddRole,
    EditRole,
    SyncRole,
    Confirm,
  },
  props: {
    allowRightClick: {
      type: Boolean,
      default: true,
    },
    allowEdit: {
      type: Boolean,
      default: true,
    },
    allowDrag: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      code: null,
      changeModal: false,
      view_modal_role: false,
      mode: null,
      isLoading: false,
      parent_role_name: null,
      parent_role_code: null,
      messageConfirm: null,
      item_removing: null,
      buttonRole: [
        {
          tooltip: this.$lang.add_data,
          name: "shield-plus",
          cls: "text-primary",
          type: "add",
        },
        {
          tooltip: this.$lang.edit,
          name: "shield-edit",
          cls: "text-success",
          type: "edit",
        },
        {
          tooltip: this.$lang.assign_role,
          name: "shield-link-variant",
          cls: "text-warning",
          type: "permissions",
        },
        {
          tooltip: this.$lang.synchronize_role,
          name: "shield-sync",
          cls: "text-info",
          type: "sync",
        },
        {
          tooltip: this.$lang.remove,
          name: "shield-remove",
          cls: "text-danger",
          type: "delete",
        },
      ],
      refreshRole: false /* guidance: refresh roles in treePage component */,
      synchronizeItem: null,
      callback: () => {},
    };
  },
  methods: {
    pathOr,
    generateApiUrl,
    async submitRole() {
      try {
        this.isLoading = true;
        if (this.mode === "add") {
          await this.$refs.addRole.save();
        }
        if (this.mode === "edit") {
          await this.$refs.editRole.save();
        }
        this.view_modal_role = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.refreshRole = true;
        this.isLoading = false;
      }
    },
    methodOnClick(item, type, callback) {
      this.mode = type;
      this.callback = callback;
      switch (type) {
        case "add":
          this.parent_role_name = item.name;
          this.parent_role_code = item.code;
          this.view_modal_role = true;
          break;
        case "edit":
          this.code = item.code;
          this.view_modal_role = true;
          break;
        case "delete":
          this.ok(item);
          break;
        case "clone":
          this.cloneRole(item);
          break;
        case "permissions":
          this.assignRole(item);
          break;
        case "sync":
          this.showSyncRoleModal(item);
          break;
      }
    },
    cancel() {
      this.changeModal = false;
      this.messageConfirm = null;
      this.item_removing = null;
    },
    ok(item) {
      this.changeModal = true;
      this.messageConfirm = this.$lang.confirmDeleteRole.replace(
        "{0}",
        item.name
      );
      this.item_removing = item;
    },
    async remove_item() {
      try {
        this.isLoading = true;
        const url = `${this.$config.api_url}${this.$config.resources.role}/${this.item_removing.code}`;
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        this.refreshRole = true;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.cancel();
        this.isLoading = false;
      }
    },
    async cloneRole(item) {
      try {
        this.isLoading = false;
        const url =
          this.$config.api_url +
          this.$config.resources.role_duplicate.replace("{role_id}", item.code);
        const response = await this.$httpService.post(url);
        this.$notify.success(response.data.message);
        this.refreshRole = true;
        this.callback();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    assignRole(item) {
      let routeData = this.$router.resolve({
        name: "assignRolePermissions",
        params: {
          id: item.code,
        },
      });
      window.open(routeData.href, "_blank");
    },
    updateRefreshRole(value) {
      this.refreshRole = value;
    },
    closeModal() {
      this.view_modal_role = false;
    },
    showSyncRoleModal(item) {
      this.view_modal_role = true;
      this.synchronizeItem = item;
    },
    async addRole(getPayload) {
      try {
        this.isLoading = true;
        const url = generateApiUrl(["resources", "role"]);
        const payload = {
          ...getPayload,
          parent_code: this.parent_role_code,
          guard_name: this.$config.role_guard_name,
        };
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.closeModal();
        this.refreshRole = true;
        this.callback();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async editRole(payload) {
      try {
        this.isLoading = true;
        const url = generateApiUrl(["resources", "role_id"], [this.code]);
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
        this.closeModal();
        this.refreshRole = true;
        this.callback();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async syncRole(payload) {
      try {
        this.isLoading = true;
        const roleCode = pathOr(null, ["code"], this.synchronizeItem);
        const url = generateApiUrl(
          ["profile", "role_permission_copy"],
          [roleCode]
        );
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.closeModal();
        this.refreshRole = true;
        this.callback();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
